module.exports = __webpack_public_path__ + "img/logo.cd4ef2ea.png";